import { useFlags } from 'launchdarkly-react-client-sdk';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import NewNoteView from './newNoteView';
import OldNoteView from './noteView';

type NoteViewProps = {
  note: ClientProfileContentItem;
};

const NoteView = ({ note }: NoteViewProps) => {
  const { enableBillingUpdates } = useFlags();

  if (enableBillingUpdates) {
    return <NewNoteView note={note} />;
  }
  // Old view doesn't need clientId as it uses the onEdit callback pattern
  return <OldNoteView note={note} />;
};

export default NoteView;
